import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getDistricSlice = createAsyncThunk(
  "district/getDistrictList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/district/getDistrictList",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  districts: [],
};

const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDistricSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDistricSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.districts = action.payload.result.list;
      })
      .addCase(getDistricSlice.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default districtSlice.reducer;